import { MultipleImageController } from "./multiple-image.controller";

angular
    .module("thor.shared.multipleImage.component", [])
    .component("multipleImage", {
        bindings: {
            type: "<",
            count: "<",
            orderNumber: "<",
            medias: "<"
        },
        controller: MultipleImageController,
        template: require("../../shared/multiple-image/multiple-image.html")
    });
